/* RGX My Vehicle (garage) — 2026-10-09; v2 2026-10-10 (A-Premium pattern, Rachel); v2.1 2026-10-11.
   Storage : localStorage "rgx.vehicle" = {m: make, d: model, y: "year", label: "2019 Toyota Tundra"}
             (same key and events as the RIGNOX EU store, which stores g = generation instead of y).
   Events  : window "rgx:vehicle" (detail = vehicle or null), window "rgx:open-selector".
   Loaded on every page by sections/rgx-vehicle-bar.liquid (header group). Styles: assets/rgx-garage.css.
   Bar     : [ Add vehicle > ] | [ search ]. The button shows the saved model ("Tundra") and opens the selector
             in a <dialog> drawer (bottom sheet on phones, side panel on desktop) on every page.
   Drawer  : the selector HTML (/?section_id=rgx-ymm, slow: aggregates every product) is prefetched when
             the browser is idle and on hover/touch of the triggers, and cached in localStorage per theme
             (refresh rules: v2.2 below), so the drawer opens instantly. The drawer list reads its prices live (rgx-ymm v4.5), so the
             cache never shows an old price. Cache key "rgx.ymm.v44" (was "rgx.ymm.html"): renamed so browsers drop
             copies of the older selector at once.
   Phones  : the search half opens a full-screen search page (popular vehicles + popular searches before
             typing, live results while typing) — A-Premium's mobile search.
   Back    : v2.1 (Rachel 2026-10-11): opening the drawer or the search page adds one history entry, so the
             phone back gesture / back button closes it instead of leaving the page; closing it any other way
             (X, Esc, backdrop, auto-close on a product page) removes that entry again. Work that must run after
             the close (scrolling to the fit card) waits until that history step has landed, because the
             browser restores the old scroll position on it.
   Search  : the bar's search is the theme's predictive search; when it finds nothing, its
             "No results found" line becomes "Not available yet for the <query> — tell us your build"
             (/pages/contact?build=<query>, a one-tap vehicle request via rgx-overrides.js §2b).
   Fit rows: "make|model|yearFrom|yearTo;" on [data-rgx-fit] (product cards, snippets/rgx-card-variant-hint)
             and [data-rgx-fit-status] (product page, snippets/rgx_compatibility). selector_only alias
             records count as a fit (the buyer may have picked the alias).
   Links   : ?ymm=YEAR|Make|Model on any page saves that vehicle and opens the drawer with the lights that fit.
   Product : on a product page, picking a vehicle in the drawer closes it and the card shows the answer
             (the drawer lists lights only from "Find lights for your …").
             One Fitment card whose title is the status (Rachel 2026-10-10): no vehicle -> "Check if this
             fits your vehicle" + Add vehicle; match -> "Fits your …"; otherwise "Not listed for your …" (never
             "Doesn't fit": the fitment data can be incomplete) + lights that fit / vehicle request / chat.
             A qualified match ("Non-BLIS trims only", "100 Series") shows the qualifier under the title.
             "See fit details" (full fitment list modal) stays in every state. Add to Cart / Buy Now are never
             blocked or interrupted.
   WhatsApp: (Rachel 2026-10-23) the fit card's "Message us on WhatsApp" link ([data-rgx-wa]) is rebuilt on
             click: product title + link to the selected variant (?variant= in the address bar) + "My
             vehicle: <saved vehicle>" (left blank for the buyer to type when none is saved). The same
             handler serves the Report a Problem / Start a Return links, shown only once the form is sent
             (data-wa-text): their text + the reference ID + the order number from that page's form.
   Cart    : attribute "Vehicle" is synced only when the cart already has items — never creates a cart,
             never touches line items. Buy Now (cart permalink) does not carry it yet.
   v2.2    : (Rachel 2026-10-13) drawer cache no longer waits out 6 h. The key carries the number of
             products on the store (data-ver on the bar), so publishing / unpublishing a product drops it at
             once; a copy older than 15 min still opens the drawer instantly but is refreshed in the background
             for the next open (fitment edits show up within ~15 min). Hard limit 24 h. Key "rgx.ymm.v46" (bump it
             whenever sections/rgx-ymm.liquid changes, so nobody keeps the old drawer for 15 min).
             Bar search: Shopify pads the predictive results with loose matches (tundra -> Lexus RX350,
             bronco -> Jeep Wrangler, 2015 F-150 -> 2009-2014); product rows whose title lacks a query word
             are removed, a 4-digit year counts when it falls inside the title's year range. If no row would
             be left, the list stays as Shopify sent it. Same rule as the RIGNOX EU bar. */
(function () {
  'use strict';
  if (window.RGXGarage) return;
  var KEY = 'rgx.vehicle';
  var CK = 'rgx.ymm.v46';
  var TTL = 24 * 3600 * 1000;
  var FRESH = 15 * 60 * 1000;
  var THEME = String((window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '');
  var VER = '';
  try { localStorage.removeItem('rgx.ymm.html'); localStorage.removeItem('rgx.ymm.v44'); localStorage.removeItem('rgx.ymm.v45'); } catch (e) {}

  function label(v) { return v ? [v.y, v.m, v.d].join(' ') : ''; }
  function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function get() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      return v && v.m && v.d && v.y ? v : null;
    } catch (e) { return null; }
  }
  function set(v) {
    if (v && v.m && v.d && v.y) {
      v = { m: v.m, d: v.d, y: String(v.y) };
      v.label = label(v);
      try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
    } else {
      v = null;
      try { localStorage.removeItem(KEY); } catch (e) {}
    }
    window.dispatchEvent(new CustomEvent('rgx:vehicle', { detail: v }));
    syncCart();
  }
  /* qualifiers of the matching fitment records: null = no match, [] = an unconditional match exists */
  function matchNotes(rows, v) {
    if (!v || !rows) return null;
    var y = parseInt(v.y, 10), hit = false, plain = false, notes = [];
    rows.split(';').forEach(function (r) {
      if (!r) return;
      var p = r.split('|');
      if (p[0] !== v.m || p[1] !== v.d || y < parseInt(p[2], 10) || y > parseInt(p[3], 10)) return;
      hit = true;
      var q = (p[4] || '').trim();
      if (!q) plain = true; else if (notes.indexOf(q) === -1) notes.push(q);
    });
    return hit ? (plain ? [] : notes) : null;
  }
  function fits(rows, v) {
    if (!v || !rows) return false;
    var y = parseInt(v.y, 10);
    return rows.split(';').some(function (r) {
      if (!r) return false;
      var p = r.split('|');
      return p[0] === v.m && p[1] === v.d && y >= parseInt(p[2], 10) && y <= parseInt(p[3], 10);
    });
  }

  /* cart attribute "Vehicle" */
  var syncing = false;
  function syncCart() {
    if (syncing) return;
    syncing = true;
    var want = label(get());
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var have = (c && c.attributes && c.attributes.Vehicle) || '';
        if (!c || !c.item_count || have === want) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { Vehicle: want } })
        });
      })
      .catch(function () {})
      .then(function () { syncing = false; });
  }

  /* selector HTML for the drawer: cache -> network (one request per page at most).
     v2.2: stale-while-revalidate — an old-but-valid copy is used now and refreshed in the background. */
  var pending = null, refreshing = false;
  function cacheGet() {
    try {
      var c = JSON.parse(localStorage.getItem(CK) || 'null');
      if (c && c.k === THEME + '|' + VER && c.t > Date.now() - TTL && c.h) return c;
    } catch (e) {}
    return null;
  }
  function cachePut(h) {
    try { localStorage.setItem(CK, JSON.stringify({ k: THEME + '|' + VER, t: Date.now(), h: h })); } catch (e) {}
  }
  function loadSelector(src) {
    return fetch(src, { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (h) {
        if (h.indexOf('data-rgx-ymm') === -1) throw new Error('no selector');
        cachePut(h);
        return h;
      });
  }
  function fetchSelector(src) {
    if (pending) return pending;
    var c = cacheGet();
    if (c) {
      if (!refreshing && c.t < Date.now() - FRESH) {
        refreshing = true;
        loadSelector(src).catch(function () {});
      }
      pending = Promise.resolve(c.h);
      return pending;
    }
    pending = loadSelector(src).catch(function (e) { pending = null; throw e; });
    return pending;
  }

  /* v2.2: bar search — drop loose product matches (see header) */
  function words(t) { return String(t).toLowerCase().split(/[^0-9a-z.]+/).filter(Boolean); }
  function titleFits(title, toks) {
    var ws = words(title), flat = ws.join(''), spans = [], m, re = /((?:19|20)\d\d)\s*[-–—]\s*((?:19|20)\d\d)/g;
    while ((m = re.exec(title))) spans.push([+m[1], +m[2]]);
    return toks.every(function (t) {
      if (/^(19|20)\d\d$/.test(t) && spans.length) {
        return spans.some(function (r) { return +t >= r[0] && +t <= r[1]; });
      }
      return ws.some(function (w) { return w.indexOf(t) === 0; }) || (t.length > 2 && flat.indexOf(t) > -1);
    });
  }
  function refineResults(box, q) {
    var toks = words(q);
    if (!toks.length) return;
    var rows = Array.prototype.slice.call(box.querySelectorAll('ul[data-type="products"] > li'));
    var drop = rows.filter(function (li) {
      var t = li.querySelector('[data-product] > .visually-hidden');
      return t && !titleFits(t.textContent, toks);
    });
    if (!drop.length || drop.length === rows.length) return;
    drop.forEach(function (li) { li.parentNode.removeChild(li); });
  }

  /* vehicle + search bar (sections/rgx-vehicle-bar.liquid) */
  function bar() {
    var root = document.querySelector('[data-rgx-vb]');
    if (!root) return;
    var lbl = root.querySelector('[data-vb-label]');
    var tog = root.querySelector('[data-vb-toggle]');
    var dlg = root.querySelector('[data-vb-dialog]');
    var sdlg = root.querySelector('[data-vb-sdialog]');
    var slot = root.querySelector('[data-vb-slot]');
    var title = root.querySelector('[data-vb-title]');
    var cur = root.querySelector('[data-vb-current]');
    var curLbl = root.querySelector('[data-vb-current-label]');
    var clr = root.querySelector('[data-vb-clear]');
    var src = root.getAttribute('data-src');
    VER = root.getAttribute('data-ver') || '';
    var loaded = false;

    /* v2.1 back gesture: one history entry per open dialog (see header). */
    var afterBack = null;
    function showDlg(d) {
      if (!d || d.open) return;
      d.showModal();
      try { history.pushState({ rgxDlg: 1 }, ''); d.__rgxHist = true; } catch (e) { d.__rgxHist = false; }
    }
    function trackDlg(d) {
      if (!d) return;
      d.addEventListener('close', function () {
        var after = d.__rgxAfter || null;
        d.__rgxAfter = null;
        if (d.__rgxHist) {
          d.__rgxHist = false;
          afterBack = after || function () {};
          try { history.back(); return; } catch (e) { afterBack = null; }
        }
        if (after) after();
      });
    }
    window.addEventListener('popstate', function () {
      if (afterBack) { var f = afterBack; afterBack = null; setTimeout(f, 0); return; }
      [dlg, sdlg].forEach(function (d) {
        if (d && d.open && d.__rgxHist) { d.__rgxHist = false; d.close(); }
      });
    });
    trackDlg(dlg);
    trackDlg(sdlg);

    function render(v) {
      /* button shows the model only ("Tundra", Rachel 2026-10-10 — A-Premium style); the full
         "2019 Toyota Tundra" is in the drawer, the tooltip and the screen-reader name */
      lbl.textContent = v ? v.d : root.getAttribute('data-empty');
      if (v) { tog.setAttribute('aria-label', 'My vehicle: ' + v.label + '. Change vehicle'); tog.title = v.label; }
      else { tog.removeAttribute('aria-label'); tog.removeAttribute('title'); }
      root.classList.toggle('rgx-vb--set', !!v);
      title.textContent = title.getAttribute(v ? 'data-change' : 'data-add');
      cur.hidden = !v;
      if (v) curLbl.textContent = v.label;
    }
    function prefetch() { fetchSelector(src).catch(function () {}); }
    /* scripts inserted via innerHTML don't run — re-create them */
    function inject(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var wrap = tmp.firstElementChild && tmp.firstElementChild.querySelector('[data-rgx-ymm]') ? tmp.firstElementChild : tmp;
      slot.innerHTML = '';
      while (wrap.firstChild) slot.appendChild(wrap.firstChild);
      Array.prototype.slice.call(slot.querySelectorAll('script')).forEach(function (old) {
        var t = (old.getAttribute('type') || '').toLowerCase();
        if (t && t !== 'text/javascript' && t !== 'module') return;
        var s = document.createElement('script');
        s.textContent = old.textContent;
        old.parentNode.replaceChild(s, old);
      });
    }
    function load() {
      if (loaded) return;
      loaded = true;
      fetchSelector(src).then(inject).catch(function () {
        loaded = false;
        slot.innerHTML = '<p class="rgx-vb__err">Couldn’t load the vehicle selector. Please try again.</p>';
      });
    }
    /* run=true (product page "Find lights for your …"): list everything that fits the saved
       vehicle right away — the selector preselects it from localStorage, we press its button. */
    function runSearch() {
      var go = slot.querySelector('[data-ymm-go]');
      if (go && !go.disabled) go.click();
    }
    /* On a product page (it has the fit card) the drawer is a "check" drawer: picking a vehicle saves
       it, closes the drawer and the card shows the answer (fits / not listed) — Rachel 2026-10-10.
       Only "Find lights for your …" (run) keeps the drawer open with the list of lights that fit. */
    var check = false;
    window.addEventListener('rgx:vehicle', function (e) {
      if (!check || !e.detail || !dlg.open) return;
      check = false;
      /* scroll to the card only after the drawer's history entry is gone (it restores the old scroll) */
      dlg.__rgxAfter = function () {
        var card = document.querySelector('[data-rgx-fit-status]');
        if (!card) return;
        var r = card.getBoundingClientRect();
        if (r.top < 80 || r.bottom > window.innerHeight) {
          try { card.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) { card.scrollIntoView(); }
        }
      };
      dlg.close();
    });
    function open(e) {
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var run = !!(e && e.detail && e.detail.run);
      check = !run && !!document.querySelector('[data-rgx-fit-status]');
      if (run && slot.querySelector('[data-ymm-go]')) runSearch();
      else if (run) fetchSelector(src).then(function () { setTimeout(runSearch, 50); }).catch(function () {});
      load();
      showDlg(dlg);
      document.documentElement.classList.add('rgx-vb-lock');
      setTimeout(function () {
        var first = slot.querySelector('[data-ymm-make]');
        if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
      }, 120);
    }
    function close() { if (dlg && dlg.open) dlg.close(); }
    tog.addEventListener('click', function () { open(); });
    ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) { tog.addEventListener(ev, prefetch, { passive: true }); });
    root.querySelector('[data-vb-close]').addEventListener('click', close);
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('rgx-vb-lock'); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    clr.addEventListener('click', function () { set(null); });
    window.addEventListener('rgx:open-selector', open);
    window.addEventListener('rgx:prefetch-selector', prefetch);
    window.addEventListener('rgx:vehicle', function (e) { render(e.detail); });
    render(get());

    /* ?ymm=YEAR|Make|Model links (old homepage selector links in emails, ads, posts): save the vehicle and
       open the drawer with the lights that fit. The parameter is removed from the address bar first, so the
       drawer's history entry (v2.1) sits on the clean URL. */
    var qm = /[?&]ymm=([^&#]+)/.exec(location.search);
    if (qm) {
      var qp = decodeURIComponent(qm[1].replace(/\+/g, ' ')).split('|');
      try {
        var u = new URL(location.href);
        u.searchParams.delete('ymm');
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
      if (qp.length === 3 && /^\d{4}$/.test(qp[0]) && qp[1] && qp[2]) {
        set({ y: qp[0], m: qp[1], d: qp[2] });
        open({ detail: { run: true } });
      }
    }
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    idle(prefetch, { timeout: 4000 });

    /* phones: full-screen search page */
    var sopen = root.querySelector('[data-vb-sopen]');
    var sempty = root.querySelector('[data-vb-sempty]');
    if (sdlg && sopen && typeof sdlg.showModal === 'function') {
      var sin = sdlg.querySelector('.rgx-vb-sdlg__input');
      var syncEmpty = function () { if (sempty) sempty.hidden = !!(sin && sin.value.trim()); };
      sopen.addEventListener('click', function () {
        showDlg(sdlg);
        document.documentElement.classList.add('rgx-vb-lock');
        syncEmpty();
        if (sin) { try { sin.focus(); } catch (e) {} }
      });
      sdlg.querySelector('[data-vb-sclose]').addEventListener('click', function () { sdlg.close(); });
      sdlg.addEventListener('close', function () { document.documentElement.classList.remove('rgx-vb-lock'); });
      if (sin) sin.addEventListener('input', syncEmpty);
    }

    /* predictive search with no result -> vehicle request line (bar field and phone search page) */
    var contact = root.getAttribute('data-contact') || '/pages/contact';
    Array.prototype.slice.call(root.querySelectorAll('.rgx-vb__results')).forEach(function (box) {
      var input = box.parentNode && box.parentNode.querySelector('.rgx-vb__input');
      if (!input || !window.MutationObserver) return;
      new MutationObserver(function () {
        var q = input.value.replace(/\s+/g, ' ').trim().slice(0, 80);
        if (q) refineResults(box, q);
        var p = box.querySelector('.predictive-search__text');
        if (!p || p.getAttribute('data-rgx') === '1') return;
        if (!q) return;
        p.setAttribute('data-rgx', '1');
        p.classList.add('rgx-vb__nores');
        p.innerHTML = esc(root.getAttribute('data-msg-none')) + ' <strong>' + esc(q) + '</strong> — <a href="' +
          contact + '?build=' + encodeURIComponent(q) + '">' + esc(root.getAttribute('data-msg-cta')) + ' →</a>';
      }).observe(box, { childList: true, subtree: true });
    });
  }

  /* product page fit status (snippets/rgx_compatibility.liquid): the Fitment Check card's title is the status */
  function statuses() {
    Array.prototype.slice.call(document.querySelectorAll('[data-rgx-fit-status]')).forEach(function (el) {
      if (el.__rgx) return;
      el.__rgx = true;
      var txt = el.querySelector('[data-fs-text]');
      var note = el.querySelector('[data-fs-note]');
      var openBtn = el.querySelector('[data-fs-open]');
      var openLbl = el.querySelector('[data-fs-open-label]') || openBtn;
      var more = el.querySelector('[data-fs-more]');
      var find = el.querySelector('[data-fs-find]');
      var req = el.querySelector('[data-fs-request]');
      var chat = el.querySelector('[data-fs-chat]');
      openBtn.addEventListener('click', function () { window.dispatchEvent(new CustomEvent('rgx:open-selector')); });
      ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) {
        openBtn.addEventListener(ev, function () { window.dispatchEvent(new CustomEvent('rgx:prefetch-selector')); }, { passive: true });
      });
      if (find) find.addEventListener('click', function () {
        window.dispatchEvent(new CustomEvent('rgx:open-selector', { detail: { run: true } }));
      });
      if (chat) chat.addEventListener('click', function () {
        var inbox = document.querySelector('inbox-online-store-chat');
        var b = inbox && inbox.shadowRoot && inbox.shadowRoot.querySelector('button');
        if (b) { b.click(); return; }
        window.location.href = '/pages/contact';
      });
      function render(v) {
        if (!v) {
          el.setAttribute('data-state', 'none');
          txt.textContent = el.getAttribute('data-ask') || 'Check if this fits your vehicle';
          openLbl.textContent = el.getAttribute('data-add') || 'Add vehicle';
          if (more) more.hidden = true;
          /* 2026-11-03 option D: no vehicle -> title is the product's own fit ("Fits 2007–2014 …"), note = its qualifier */
          var askNote = el.getAttribute('data-ask-note') || '';
          if (note) { note.textContent = askNote; note.hidden = !askNote; }
          return;
        }
        var notes = matchNotes(el.getAttribute('data-rows'), v);
        var ok = notes !== null;
        if (note) {
          note.textContent = ok && notes.length ? notes.join(' · ') : '';
          note.hidden = !(ok && notes.length);
        }
        el.setAttribute('data-state', ok ? 'ok' : 'no');
        txt.textContent = (ok ? 'Fits your ' : 'Not listed for your ') + v.label;
        openLbl.textContent = el.getAttribute('data-change') || 'Change vehicle';
        if (more) more.hidden = ok;
        if (!ok) {
          if (find) find.textContent = 'Find lights for your ' + v.d;
          if (req) req.href = '/pages/contact?build=' + encodeURIComponent(v.label);
        }
      }
      render(get());
      window.addEventListener('rgx:vehicle', function (e) { render(e.detail); });
    });
  }

  /* product card "Fits your vehicle" tag (snippets/rgx-card-variant-hint.liquid) */
  function cards(v) {
    Array.prototype.slice.call(document.querySelectorAll('[data-rgx-fit]')).forEach(function (b) {
      b.hidden = !fits(b.getAttribute('data-rgx-fit'), v);
    });
  }

  /* fit card WhatsApp link (snippets/rgx_compatibility.liquid) */
  function waClick(e) {
    var a = e.target.closest && e.target.closest('[data-rgx-wa]');
    if (!a) return;
    if (a.hasAttribute('data-wa-text')) {
      /* Report a Problem / Start a Return "sent" panel: add the reference ID and the order number from the form */
      var box = a.closest('.rgx-wc');
      var ref = box && box.querySelector(a.getAttribute('data-wa-ref'));
      var order = box && box.querySelector('input[name="order"]');
      a.href = a.getAttribute('data-wa-base') + '?text=' + encodeURIComponent(a.getAttribute('data-wa-text') +
        '\n' + a.getAttribute('data-wa-ref-label') + ': ' + (ref ? ref.textContent.trim() : '') +
        '\nOrder number: ' + (order ? order.value.trim() : ''));
      return;
    }
    var url = a.getAttribute('data-wa-url');
    var variant = new URLSearchParams(window.location.search).get('variant');
    if (variant) url += '?variant=' + encodeURIComponent(variant);
    var v = get();
    var text = 'Hi RIGNOX! Question about the ' + a.getAttribute('data-wa-title') + ': ' + url +
      '\nMy vehicle: ' + (v ? v.label : '');
    a.href = a.getAttribute('data-wa-base') + '?text=' + encodeURIComponent(text);
  }

  window.RGXGarage = { get: get, set: set, fits: fits, label: label };

  function init() {
    bar();
    statuses();
    document.addEventListener('click', waClick);
    var v = get();
    cards(v);
    window.addEventListener('rgx:vehicle', function (e) { cards(e.detail); });
    /* cards added later (load more, quick view, drawer) */
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { cards(get()); statuses(); }, 200);
    }).observe(document.body, { childList: true, subtree: true });
    if (v) syncCart();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { if (get()) syncCart(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
